"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("./styles/main.css");
const FileDropZone_1 = require("./components/FileDropZone");
const BCFViewer_1 = __importDefault(require("./components/BCFViewer"));
document.addEventListener('DOMContentLoaded', () => {
    const dropZoneElement = document.getElementById('drop-zone');
    const viewerElement = document.getElementById('bcf-viewer');
    if (!dropZoneElement || !viewerElement) {
        console.error('Required DOM elements not found');
        return;
    }
    const bcfViewer = new BCFViewer_1.default(viewerElement);
    const fileDropZone = new FileDropZone_1.FileDropZone(dropZoneElement);
    fileDropZone.onFileDropped = (file) => {
        bcfViewer.loadBCFFile(file);
    };
});
